
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 15.538 11.788"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.413 11.538a.375.375 0 01-.266-.11l-3.75-3.75a.375.375 0 01.53-.53l3.486 3.486L14.648.397a.375.375 0 01.53.531l-10.5 10.5a.369.369 0 01-.265.11z","fill":"#fff","stroke":"#fff","stroke-width":".5"}})])
          )
        }
      }
    